module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_7042.e3795a83.png";